var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerSquarePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_to_photos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 6.30469H2V20.3047C2 21.4047 2.9 22.3047 4 22.3047H18V20.3047H4V6.30469ZM20 2.30469H8C6.9 2.30469 6 3.20469 6 4.30469V16.3047C6 17.4047 6.9 18.3047 8 18.3047H20C21.1 18.3047 22 17.4047 22 16.3047V4.30469C22 3.20469 21.1 2.30469 20 2.30469ZM20 16.3047H8V4.30469H20V16.3047ZM13 15.3047H15V11.3047H19V9.30469H15V5.30469H13V9.30469H9V11.3047H13V15.3047Z",
    fill: "#1D74CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerSquarePlus);
export default __webpack_public_path__ + "static/media/layer_square_plus.a256768b9298b0fdeaa80407398afe4d.svg";
export { ForwardRef as ReactComponent };